"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableDrawer = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var Drawer_1 = require("../Drawer");
var styles_1 = require("../styles");
var drawerWidth = 474;
var useStyles = (0, styles_1.makeStyles)({
    drawerPaper: {
        width: drawerWidth,
        position: 'absolute',
    },
    drawerPaperExpanded: {
        width: '100%',
    },
});
function ExpandableDrawer(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.expanded, expanded = _c === void 0 ? false : _c, _d = _a.anchor, anchor = _d === void 0 ? 'left' : _d, children = _a.children;
    var classes = useStyles();
    return (react_1.default.createElement(Drawer_1.Drawer, { open: open, anchor: anchor, variant: "persistent", classes: {
            paper: (0, clsx_1.default)(classes.drawerPaper, open && expanded && classes.drawerPaperExpanded),
        } }, children));
}
exports.ExpandableDrawer = ExpandableDrawer;
exports.default = ExpandableDrawer;
//# sourceMappingURL=index.js.map